import { axios } from "../utils/axios.create";
import { IAction } from "../domain/action.interface";

export interface ActionRequest {
	code: string;
	name: string;
	description: string;
	type: string;
	link?: string;
	order: number;
	parentActionId?: string;
	createdBy: string;
}

export interface ActionUpdateRequest extends Omit<ActionRequest, "createdBy"> {
	_id: string;
	updatedBy: string;
}

export interface ActionsResponse {
	statusCode: number;
	body: {
		data: IAction[];
		pagination: {
			currentPage: number;
			pageSize: number;
			totalCount: number;
			totalPages: number;
		};
	};
}

export const getActions = async (
	search?: string,
	pageNumber?: number,
	pageSize?: number,
): Promise<ActionsResponse> => {
	const params = new URLSearchParams();
	if (search) params.append("search", search);
	if (pageNumber) params.append("pageNumber", pageNumber.toString());
	if (pageSize) params.append("pageSize", pageSize.toString());

	const queryString = params.toString();
	const url = `/actions${queryString ? `?${queryString}` : ""}`;

	return axios
		.get(url)
		.then((res) => res.data)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const getAllActions = async (): Promise<ActionsResponse> => {
	// Get all actions by setting a high page size (1000 should be more than enough)
	const params = new URLSearchParams();
	params.append("pageSize", "1000");

	const url = `/actions?${params.toString()}`;

	return axios
		.get(url)
		.then((res) => res.data)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const createAction = async (
	actionData: ActionRequest,
): Promise<IAction> => {
	return axios
		.post("/actions", actionData)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const updateAction = async (
	actionData: ActionUpdateRequest,
): Promise<IAction> => {
	const { _id, ...updateData } = actionData;
	return axios
		.put(`/actions/${_id}`, updateData)
		.then((res) => res.data.body)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};

export const deleteAction = async (actionId: string): Promise<void> => {
	return axios
		.delete(`/actions/${actionId}`)
		.then(() => undefined)
		.catch((err) => {
			return Promise.reject(err.response?.data || err);
		});
};
